import React, { useState } from "react";
import { AlertTriangle, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function PaymentBanner({ issue, isOwner }: { issue: any; isOwner: boolean }) {
  const [busy, setBusy] = useState(false);
  if (!issue) return null;
  const ended = issue.status === "ended";
  const go = async () => {
    setBusy(true);
    try {
      const { data } = ended
        ? await api.post("/payments/checkout", { plan: "pro", origin_url: window.location.origin })
        : await api.post("/billing/portal", { origin_url: window.location.origin });
      window.location.href = data.checkout_url || data.url;
    } catch (e) {
      toast.error(errMsg(e));
      setBusy(false);
    }
  };
  const amount = issue.amount != null ? `$${Number(issue.amount).toFixed(2)}` : "your renewal";
  const msg = ended
    ? "Your Pro plan has ended because the renewal payment didn't go through. Pro features are switched off."
    : `We couldn't charge ${amount} for your Pro renewal. Stripe will retry automatically${issue.next_attempt ? ` on ${new Date(issue.next_attempt).toLocaleDateString()}` : ""}.`;
  return (
    <div className="mb-5 flex flex-col gap-3 rounded-sm border border-rose-300 bg-rose-50 p-4 text-rose-900 sm:flex-row sm:items-center" role="alert" data-testid={ended ? "payment-ended-banner" : "payment-failed-banner"}>
      <AlertTriangle className="h-5 w-5 shrink-0 text-rose-600" />
      <p className="flex-1 text-sm font-medium" data-testid="payment-banner-message">
        {msg} {!isOwner && "Please ask your account owner to update the billing details."}
      </p>
      {isOwner && (
        <Button onClick={go} disabled={busy} className="bg-rose-600 text-white hover:bg-rose-700" data-testid={ended ? "payment-banner-resubscribe-button" : "payment-banner-update-card-button"}>
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : ended ? "Resubscribe" : "Update card"}
        </Button>
      )}
    </div>
  );
}
